import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
})
export class ButtonComponent implements OnInit {
    @Input() label: string;
    @Input() hint?: string;
    @Input() classes?: string[];
    @Input() actionCallback: any;
    @Input() disabled?: boolean;
    @Input() otherProperties?: any;
    @Input() tip?: string;

    constructor() {}

    ngOnInit(): void {
    }

    onClick(callback): void {
        callback(this.otherProperties);
    }
}
